import * as React from 'react';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router';
import Clear from 'material-ui/svg-icons/content/clear';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { JobRunsForm } from '@modules/jobs/JobRunsForm';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const JobRunsGrid = compose<any, any>(
  withRouter,
  withColumns(Agenda.JOB_RUNS),
  withProps(({ item, columns }) => ({
    name: 'JobRunsGrid',
    url: `/metropolis/api/jobs/${item}/runs`,
    Form: withProps({ jobId: item })(JobRunsForm),
    urlItemName: 'valueItem',
    gridProps: {
      deleteFiltersTooltip: 'Reset filtrů',
      deleteFiltersIcon: <Clear />,
      columns,
      adding: false,
      editing: true,
      ActionBar: () => <ColumnManager agenda={Agenda.JOB_RUNS} />,
      sort: 'created',
      filtering: true,
      filterRow: true,
      showCheckboxes: true,
      deleting: false,
      locale: 'cz',
      version: 1
    },
    dialog: true,
    dialogProps: {
      contentStyle: {
        width: '50vw',
        overflowY: 'scroll',
        transform: 'none'
      }
    }
  }))
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/jobs/JobRunsGrid.tsx